module.exports = {
    ch: '零壹贰叁肆伍陆柒捌玖'
    ,ch_u: '个拾佰仟万亿'
    ,ch_f: '负'
    ,ch_d: '点'
    ,m_t: '人民币'
    ,m_z: '整'
    ,m_u: '元角分'
}


//////////////////
// WEBPACK FOOTER
// ./~/nzh/src/langs/cn_b.js
// module id = OhJW
// module chunks = 9